import { releaseAssetUrl } from '../services/runtimeAssets.js';

let watermarkImage = null;
let watermarkPromise = null;

export function loadRoadWatermark() {
  if (watermarkImage?.complete && watermarkImage.naturalWidth) return Promise.resolve(watermarkImage);
  if (watermarkPromise) return watermarkPromise;
  watermarkPromise = new Promise((resolve, reject) => {
    const image = new Image();
    image.onload = () => {
      watermarkImage = image;
      resolve(image);
    };
    image.onerror = () => reject(new Error('Wanli road watermark asset failed to load'));
    image.src = releaseAssetUrl('/assets/brand/wanli-script-gold-v1.webp');
  });
  return watermarkPromise;
}

export function drawRoadWatermark(ctx, width, height, { widthRatio = .4, opacity = .1 } = {}) {
  if (!watermarkImage?.complete || !watermarkImage.naturalWidth) return false;
  const targetWidth = width * widthRatio;
  const targetHeight = targetWidth * watermarkImage.naturalHeight / watermarkImage.naturalWidth;
  ctx.save();
  ctx.globalAlpha = opacity;
  ctx.globalCompositeOperation = 'multiply';
  ctx.filter = 'grayscale(1) brightness(.72) contrast(.72)';
  ctx.drawImage(watermarkImage, (width - targetWidth) / 2, (height - targetHeight) / 2, targetWidth, targetHeight);
  ctx.restore();
  return true;
}
